export default Object.freeze({
  Australia: 'AUS'
})
